import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const GenericComingSoonSection = () => (
  <Box textAlign="center" py={12}>
    <Text fontSize="xl" fontWeight="600" color="gray.500">
      Coming Soon
    </Text>
  </Box>
);

export default GenericComingSoonSection;
